import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../../context-store";
import dateUtils from "../../../utils/date-utils";
import ConfirmScheduleDetailsModel from "../../../models/interviewer/response/ConfirmScheduleDetailsModel";
import InterviewerService from '../../../services/interviewer/interviewer-service';
import toasterUtils from "../../../utils/toaster-utils";
import modalUtils from "../../../utils/modal-utils";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import { GeneralPoupConfig, ModalSize } from "../../../models/modal-types";
import ConfirmInterviewPopUp from "../dashboard/ConfirmInterviewComponent";
import PickUpInterviewDetailsComponent from "./PickUpInterviewDetailsComponent";

const PickUpScheduleComponent = () => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [pickUpSchedules, setPickUpSchedules] = useState<ConfirmScheduleDetailsModel[]>([]);

    useEffect(() => {
        getPickUpSchedules();
    }, []);

    const getPickUpSchedules = () => {
        if (loggedInUser) {
            modalUtils.showLoader();
            InterviewerService.getInterviewsToBePicked(loggedInUser.profileId).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                setPickUpSchedules(res.data);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError("Erorr fetching Schedules");
            });
        }
    };

    const columnsSchedules = [
        { key: "InterviewDate", text: "Interview Date", sort: false, searchable: false },
        { key: "TimeSlotName", text: "Time", sort: false, searchable: false },
        { key: "ExperienceName", text: "Years of Experience", sort: false, searchable: false },
        { key: "KeyResponsibilities", text: "Special Notes", sort: false, searchable: false },
        { key: "CandidateName", text: "Your booked slots for the day", sort: false, searchable: false },
        { key: "Actions", text: "PickUp", sort: false, searchable: false }
    ];

    const savePickUpSchedule = (interviewId: string) => {
        if (loggedInUser) {
            modalUtils.showLoader();
            InterviewerService.updateInterviewerForSchedule(interviewId, loggedInUser.profileId).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                toasterUtils.showSuccess(res.informationMessages.toString());
                getPickUpSchedules();
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError("Erorr fetching Schedules");
            });
        }
    };

    const viewInterview = (interview: ConfirmScheduleDetailsModel) => {
        const config: GeneralPoupConfig = {
            title: "Interview Details",
            content: (
                <PickUpInterviewDetailsComponent
                    interviewId={interview.interviewId}
                    candidateId={interview.candidateId}
                    resumeTitle=""
                    onPickInterview={pickInterviewHandler}
                />
            ),
            size: ModalSize.LG
            // className: "model-min-height-500"
        };
        modalUtils.showPopup(config);
    };

    const pickInterviewHandler = (interviewId: string) => {
        savePickUpSchedule(interviewId);
    };

    return (
        <div className="card card-white">
            <div className="card-body">
                <div className="row">
                    <div className="col-md-12">
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        {columnsSchedules.map((column: any) => (
                                            <TableCell key={column.key} className="table-header-cell">
                                                <span>{column.text}</span>
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {pickUpSchedules.length > 0 && pickUpSchedules.map((row: ConfirmScheduleDetailsModel, index) => (
                                        <TableRow
                                            key={index}
                                            sx={{
                                                backgroundColor: index % 2 === 0 ? 'white' : '#f5f5f5' // even rows white, odd rows light gray
                                            }}
                                        >
                                            <TableCell>{dateUtils.getFormattedDateFromDate(row.interviewDate)}</TableCell>
                                            <TableCell>{row.timeSlotName}</TableCell>
                                            <TableCell>{row.experienceName}</TableCell>
                                            <TableCell>{row.keyResponsibilities}</TableCell>
                                            <TableCell>{row.candidateName}</TableCell>
                                            <TableCell>
                                                <a onClick={() => { viewInterview(row); }} title="View Interview">
                                                    <i className="fa fa-eye grid-icon blue"></i>
                                                </a>
                                                {/* <a onClick={() => { savePickUpSchedule(row.interviewId); }} title="Pick Schedule">
                                                    <i className="fa fa-check grid-icon blue"></i>
                                                </a> */}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                    {pickUpSchedules.length < 1 && (
                                        <TableRow>
                                            <TableCell colSpan={6} align="center">
                                                No Interviews Available.
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PickUpScheduleComponent;